import { withKeys as _withKeys, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "flex items-center gap-3"
};
var _hoisted_2 = {
  class: "flex items-center gap-2"
};
var _hoisted_3 = {
  class: "text-surface-600 text-sm"
};
export default {
  __name: 'DateRangeSelector',
  props: {
    displayLabel: {
      type: String,
      required: true
    },
    isPreviousDisabled: {
      type: Boolean,
      default: false
    },
    isNextDisabled: {
      type: Boolean,
      default: false
    },
    previousLabel: {
      type: String,
      default: "Previous"
    },
    nextLabel: {
      type: String,
      default: "Next"
    },
    previousTooltip: {
      type: String,
      default: ""
    },
    nextTooltip: {
      type: String,
      default: ""
    },
    widthOfLabel: {
      type: String,
      default: "150px"
    }
  },
  emits: ["previous", "next", "reset"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var onPrevious = function onPrevious() {
      if (!props.isPreviousDisabled) {
        emit("previous");
      }
    };
    var onNext = function onNext() {
      if (!props.isNextDisabled) {
        emit("next");
      }
    };
    var onReset = function onReset() {
      emit("reset");
    };
    return function (_ctx, _cache) {
      var _component_Button = _resolveComponent("Button");
      var _directive_tooltip = _resolveDirective("tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("i", {
        class: "fa-solid fa-calendar text-surface-500 text-lg hover:!text-primary-500 cursor-pointer",
        onClick: onReset,
        onKeyup: _withKeys(onReset, ["enter"]),
        tabindex: "0"
      }, null, 32), _createElementVNode("div", _hoisted_2, [_withDirectives(_createVNode(_component_Button, {
        size: "small",
        severity: "primary",
        icon: "pi pi-chevron-left",
        variant: "text",
        "aria-label": __props.previousLabel,
        onClick: onPrevious,
        disabled: __props.isPreviousDisabled,
        pt: {
          root: {
            class: [__props.isPreviousDisabled ? 'opacity-50 cursor-not-allowed' : '!bg-primary-50 hover:!bg-primary-100', '!py-1']
          },
          icon: {
            class: __props.isPreviousDisabled ? '!text-surface-400 !text-xs' : '!text-primary-700 !text-xs'
          }
        }
      }, null, 8, ["aria-label", "disabled", "pt"]), [[_directive_tooltip, __props.previousTooltip, void 0, {
        top: true
      }]]), _createElementVNode("div", {
        class: "flex items-center justify-center gap-2 text-xs text-surface-600 border border-surface-200 rounded-lg px-3 py-1",
        style: _normalizeStyle({
          width: __props.widthOfLabel
        })
      }, [_createElementVNode("span", _hoisted_3, _toDisplayString(__props.displayLabel), 1)], 4), _withDirectives(_createVNode(_component_Button, {
        size: "small",
        severity: "primary",
        icon: "pi pi-chevron-right",
        variant: "text",
        "aria-label": __props.nextLabel,
        onClick: onNext,
        disabled: __props.isNextDisabled,
        pt: {
          root: {
            class: [__props.isNextDisabled ? 'opacity-50 cursor-not-allowed' : '!bg-primary-50 hover:!bg-primary-100', '!py-1']
          },
          icon: {
            class: __props.isNextDisabled ? '!text-surface-400 !text-xs' : '!text-primary-700 !text-xs'
          }
        }
      }, null, 8, ["aria-label", "disabled", "pt"]), [[_directive_tooltip, __props.nextTooltip, void 0, {
        top: true
      }]])])]);
    };
  }
};